<template>
    <div class="column is-four-fifths">
        <div>
            <p>{{ translate("notification_center.type_of_notification.title") }}</p>
        </div>
        <div class="mt-3">
            <h6 class="has-text-weight-bold is-size-6 mb-3 has-border">
                {{ translate("notification_center.type_of_notification.header") }}
            </h6>

            <div class="control" v-for="(notificationTypePricing, index) in mainTypes" :key="index">
                <label class="fontawesome-radio is-size-5" :class="{ 'is-disabled': !notificationTypePricing.enabled }">
                    <input
                        :disabled="!notificationTypePricing.enabled"
                        type="radio"
                        name="exclusiveNotificationType"
                        :checked="index === 0"
                        v-model="mainType"
                        :value="notificationTypePricing.type"
                    />
                    <span>
                        {{ translateType(notificationTypePricing.type) }}

                        <span v-if="notificationTypePricing.enabled" class="has-text-grey-light is-size-6">
                            {{ notificationTypePricing.price }}
                        </span>
                    </span>
                </label>
            </div>
            <div v-if="mainType === 'sms'">
                <span class="has-text-warning">
                    {{ translate("notification_center.type_of_notification.sms_price_for_country", false, [getRecognizedCountryCode()]) }}
                </span>
                <a>{{ translate("notification_center.type_of_notification.checkout_pricing") }}</a>
            </div>
        </div>

        <div class="mt-3" v-if="mainType === 'email'">
            <h6 class="has-text-weight-bold is-size-6 has-border">
                {{ translate("notification_center.email_to_get_replies") }}
            </h6>

            <p class="mb-2 has-text-warning" v-if="!isValidStateForEmailType">
                <span class="icon">
                    <i class="fa fa-exclamation-triangle" />
                </span>
                <span>{{ translate("notification_center.email_is_required") }}</span>
            </p>

            <div class="columns">
                <div class="column is-three-fifths">
                    <div class="field" :class="{ 'has-error': !emailValid }">
                        <label class="label">{{ translate("notification_center.receivers_can_reach_you_back") }}</label>
                        <input type="email" class="input" v-model="emailReplyTo" maxlength="50" />
                        <p class="help" v-if="!emailValid">
                            {{ translate("flash_messages.user_email_valid") }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-3" v-if="mainType === 'internal'">
            <h6 class="has-text-weight-bold is-size-6 has-border">
                {{ translate("notification_center.contact_data_internal") }}
            </h6>

            <p class="mb-2 has-text-warning" v-if="!isValidStateForInternalType">
                <span class="icon">
                    <i class="fa fa-exclamation-triangle" />
                </span>
                <span>{{ translate("notification_center.internal_type_required_fields") }}</span>
            </p>

            <div class="columns">
                <div class="column is-three-fifths">
                    <div class="field">
                        <label class="label">{{ translate("notification_center.internal_type_name") }}</label>
                        <input type="text" class="input" maxlength="50" v-model="nameReplyTo" />
                    </div>

                    <div class="field">
                        <label class="label">{{ translate("common.phone") }}:</label>
                        <PhoneNumberInput v-model="phoneReplyTo" />
                    </div>

                    <div class="field" :class="{ 'has-error': !emailValid }">
                        <label class="label">{{ translate("common.email") }}:</label>
                        <input class="input" type="text" v-model="emailReplyTo" maxlength="50" />
                        <p class="help" v-if="!emailValid">
                            {{ translate("flash_messages.user_email_valid") }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import apiMixin from "../../Api/apiMixin";
    import translatorMixin from "../../Common/translatorMixin";
    import errorHandlerMixin from "../../Common/errorHandlerMixin";
    import { isValidEmailOrEmpty } from "../../Common/email";
    import PhoneNumberInput from "../../Common/PhoneNumberInput.vue";
    import { mapGetters } from "vuex";

    export default {
        name: "type-of-notification-step",
        components: { PhoneNumberInput },
        mixins: [apiMixin, translatorMixin, errorHandlerMixin],
        data() {
            return {
                availableTypes: [],
            };
        },
        computed: {
            ...mapGetters("typeOfNotification", ["isValidStateForEmailType", "isValidStateForInternalType"]),
            mainTypes() {
                return this.availableTypes.filter(type => type.category === "main");
            },
            additionalTypes() {
                return this.availableTypes.filter(type => type.category === "additional");
            },
            nameReplyTo: {
                set(value) {
                    this.$store.commit("typeOfNotification/setNameReplyTo", value);
                },
                get() {
                    return this.$store.state.typeOfNotification.nameReplyTo;
                },
            },
            emailReplyTo: {
                set(value) {
                    this.$store.commit("typeOfNotification/setEmailReplyTo", value);
                },
                get() {
                    return this.$store.state.typeOfNotification.emailReplyTo;
                },
            },
            phoneReplyTo: {
                set(value) {
                    this.$store.commit("typeOfNotification/setPhoneReplyTo", value);
                },
                get() {
                    return this.$store.state.typeOfNotification.phoneReplyTo;
                },
            },
            mainType: {
                set(value) {
                    this.$store.commit("typeOfNotification/setMainType", value);
                },
                get() {
                    return this.$store.state.typeOfNotification.mainType;
                },
            },
            emailValid() {
                return isValidEmailOrEmpty(this.emailReplyTo);
            },
        },
        mounted() {
            return this.notificationsCenterApi()
                .getPricingSummary()
                .then(types => (this.availableTypes = types))
                .catch(this.handleError);
        },
        methods: {
            translateType(type) {
                return this.translate(`notification_center.create.type.` + type);
            },
            getRecognizedCountryCode() {
                const code = this.$store.state.main.userCountryCode;

                return this.translate("country." + code);
            },
        },
    };
</script>

<style scoped></style>
